/** @jsx jsx */

import React, { useState, useRef, useLayoutEffect, useEffect } from 'react';
import { css, jsx } from '@emotion/core';
import { Text } from '@chameleoncreator/creator-ui';
import isIE from 'services/isIE';
// import { getDummyScore } from 'services/scoring';
import getStore from 'services/getStore';
import 'services/ie11closestPolyfill';
import doDirtyTestContent from 'services/doDirtyTestContent';
import bulletStyles from './bulletStyles';

const store = getStore();
let { textColor = '' } = store.getState().theme;

let counter = 0;

const ReadOnlyText = ({
  content,
  className,
  useBackgroundControls,
  borderRadius,
  backgroundColor,
  bulletColor,
}) => {
  //
  const readOnlyText = useRef(null);
  const section = useRef(null);
  const hasScoring = useRef(null);

  // useLayoutEffect(() => {
  //   isIE() &&
  //   doDirtyTestContent(
  //     readOnlyText.current.querySelector('div'),
  //     false,
  //     'https://www.artstation.com/artwork/4bZ8B4'
  //   );
  // }, []);

  return (
    <Text
      ref={readOnlyText}
      className={`chameleon-text${className ? ` ${className}` : ''}`}
      as="div"
      css={css`
        ${bulletStyles(bulletColor)}
      `}
      style={{
        ...((useBackgroundControls || backgroundColor) && {
          borderRadius,
          background: backgroundColor,
          padding: borderRadius * 3,
        }),
      }}
    >
      <div
        dangerouslySetInnerHTML={{
          __html: content,
        }}
      />
    </Text>
  );
};

export default ReadOnlyText;
